const style = (theme) => {
  const output = {
    root: {
      position: 'absolute',
      zIndex: 1,
      top: 25,
      left: '5.5vw',
      width: 200,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}
export default style
